<template>
  <div class="description__left">
    <div class="content__title">
      <font-awesome-icon
        v-if="parcours"
        v-bind:icon="collapsed ? 'chevron-circle-right' : 'chevron-circle-down'"
        class="mr-2.5"
        v-bind:class="[
          {
            [`group-hover:${type_text_color(inscription.type[0].id)}`]:
              inscription.accesDetails || parcours
          }
        ]"
        size="1x" />
      <span
        class="content__title__text"
        v-bind:class="[
          {
            [`group-hover:${type_text_color(inscription.type[0].id)}`]:
              (inscription.accesDetails && !isSessionStatusCancel) || parcours
          }
        ]">
        <span data_id="titre">
          {{
            `${inscription.titre}${inscription.familleStage ? ' (Stage)' : ''}${inscription.fuseauHoraire && inscription.fuseauHoraire !== 'UTC+1 Paris' ? ` - [Fuseau horaire ${inscription.fuseauHoraire}]` : ''}`
          }}
        </span>
      </span>
    </div>

    <div
      v-if="inscription.reference"
      class="content__reference">
      Réf&nbsp;:
      <span
        data_id="reference"
        class="font-bold">
        {{ inscription.reference }} (statut :
        {{ inscription.sessionStatut.label }})
      </span>
    </div>
    <div
      v-if="inscription.commandeReference"
      class="content__reference">
      Réf&nbsp;commande&nbsp;:
      <span
        data_id="reference"
        class="font-bold">
        {{ inscription.commandeReference }}
      </span>
    </div>

    <div class="flex flex-col space-y-1">
      <div
        class="flex flex-col space-y-1"
        v-if="inscription.duree">
        <div class="flex items-center space-x-1.5">
          <font-awesome-icon v-bind:icon="['far', 'clock']" />
          <span> Durée de la formation : {{ inscription.duree }} </span>
        </div>
      </div>
      <div
        v-if="
          (inscription.sessionDates && !inscription.plateformeDureeAcces) ||
          (inscription.moduleElearning &&
            inscription.moduleElearning.accessible)
        ">
        <span class="inline-flex w-4 items-center justify-center align-middle">
          <font-awesome-icon
            v-bind:icon="['far', 'calendar-alt']"
            size="1x" />
        </span>

        <span
          v-if="!inscription.dateDebut && !inscription.dateFin"
          class="mx-2">
          <em class="text-accent-500"
            >Date{{ inscription.sessionDates.length > 1 ? 's' : null }}&nbsp;:
          </em>
          <span
            v-if="
              !(
                (inscription.moduleElearning &&
                  inscription.moduleElearning.dateDebutAcces) ||
                (inscription.plateformeDureeAcces &&
                  inscription.moduleElearning &&
                  inscription.moduleElearning.accessible)
              )
            ">
            {{ displayDates(inscription.sessionDates).join(', ') }}
          </span>
          <span
            v-if="inscription.dateDebut && inscription.dateFin"
            class="mx-2">
            {{
              `Accessible du ${inscription.dateDebut} ${inscription.dateFin ? `au ${inscription.dateFin}` : ''}`
            }}
          </span>

          <template v-if="!produit">
            <span
              v-if="
                inscription.plateformeDureeAcces &&
                inscription.moduleElearning &&
                inscription.moduleElearning.accessible
              ">
              {{
                `Accessible pendant ${inscription.plateformeDureeAcces} jour${inscription.plateformeDureeAcces > 1 ? 's' : ''}`
              }}

              {{
                inscription.moduleElearning.dateDebutAcces
                  ? `(du ${inscription.moduleElearning.dateDebutAcces} ${inscription.moduleElearning.dateFinAcces ? `au ${inscription.moduleElearning.dateFinAcces}` : ''})`
                  : ''
              }}
            </span>
          </template>
          <template v-else>
            <span
              v-if="
                inscription.moduleElearning &&
                inscription.moduleElearning.dateDebutAcces
              ">
              {{
                `Accessible du ${inscription.moduleElearning.dateDebutAcces}${inscription.moduleElearning.dateFinAcces ? ` au ${inscription.moduleElearning.dateFinAcces}` : ''} `
              }}
            </span>
          </template>
        </span>
      </div>

      <div
        v-if="(inscription.lieu || inscription.lieuIntra) && !parcours"
        class="flex items-center">
        <span class="inline-flex w-4 items-center justify-center align-middle">
          <font-awesome-icon
            icon="map-marker-alt"
            size="1x" />
        </span>
        <span class="ml-2.5 mr-1.5">
          <em class="text-accent-500">Lieu&nbsp;: </em>
          <span data_id="lieu">
            {{ inscription.lieu || inscription.lieuIntra }}
          </span>
        </span>
        <span
          v-if="inscription.mode && inscription.mode.id === 2"
          class="bg-jinius-dark-green px-1.5 py-0.5 align-text-top text-xs leading-none text-white shadow-sm">
          {{ inscription.mode.label }}
        </span>
      </div>

      <div v-if="inscription.participants && !parcours">
        <span class="inline-flex w-4 items-center justify-center align-middle">
          <font-awesome-icon
            icon="users"
            size="1x" />
        </span>
        <span
          class="mx-2"
          v-bind:class="{
            'cursor-pointer hover:underline':
              inscription.participants.length > participants_number_to_display
          }"
          v-on:click.stop="openParticipantsModal">
          <em class="text-accent-500">Participants&nbsp;: </em>
          {{ displayParticipants(inscription.participants).join(', ')
          }}{{
            inscription.participants.length > participants_number_to_display
              ? ` et ${inscription.participants.length - participants_number_to_display} autres personnes`
              : ''
          }}
          <font-awesome-icon
            v-if="
              inscription.participants.length > participants_number_to_display
            "
            icon="search-plus"
            size="sm"
            class="ml-1 text-accent-500" />
        </span>
      </div>

      <div v-if="inscription.organisateur && !parcours">
        <span class="inline-flex w-4 items-center justify-center align-middle">
          <font-awesome-icon
            icon="tag"
            size="1x" />
        </span>

        <span class="mx-2 align-middle">
          <em class="text-accent-500">Organisateur&nbsp;: </em>
          <span data_id="organisateur">
            {{ inscription.organisateur }}
          </span>
        </span>
      </div>

      <div v-if="inscription.effectifPresent">
        <span class="inline-flex w-4 items-center justify-center align-middle">
          <font-awesome-icon
            icon="users"
            size="1x" />
        </span>

        <span class="mx-2 align-middle">
          <em class="text-accent-500">Effectif Présent&nbsp;: </em>
          <span
            data_id="effectifPresent"
            class="font-bold">
            {{ inscription.effectifPresent }}
          </span>
        </span>
      </div>
      <div v-if="inscription.dureeAnim">
        <span class="inline-flex w-4 items-center justify-center align-middle">
          <font-awesome-icon
            icon="clock"
            size="1x" />
        </span>

        <span class="mx-2 align-middle">
          <em class="text-accent-500">Durée animée&nbsp;: </em>
          <span data_id="dureeAnim">
            {{ inscription.dureeAnim }}
          </span>
        </span>
      </div>
      <div>
        <div
          v-if="inscription.sessionUrlWebinaire"
          v-on:click.stop="() => goToUrl(inscription.sessionUrlWebinaire)"
          class="my-2 flex w-72 cursor-pointer items-center justify-center rounded bg-orange-500 px-4 py-2 text-center text-sm font-bold uppercase leading-none text-white shadow-sm hover:bg-orange-600">
          <font-awesome-icon icon="external-link-alt" />
          <span class="ml-2 align-middle">Accéder à la session</span>
        </div>
        <div
          v-if="
            inscription.sessionUrlParticipant &&
            inscription.sessionUrlParticipant.length === 1
          "
          v-on:click.stop="
            () => goToUrl(inscription.sessionUrlParticipant[0].url)
          "
          class="my-2 flex w-72 cursor-pointer items-center justify-center rounded bg-orange-500 px-4 py-2 text-center text-sm font-bold uppercase leading-none text-white shadow-sm hover:bg-orange-600">
          <font-awesome-icon icon="external-link-alt" />
          <span class="ml-2 align-middle">Accéder à la session</span>
        </div>
        <div
          v-if="
            inscription.moduleElearning &&
            inscription.moduleElearning.accessible
          "
          v-on:click.stop="openElearningModule"
          class="my-2 flex w-72 cursor-pointer items-center justify-center rounded bg-orange-500 px-4 py-2 text-center text-sm font-bold uppercase leading-none text-white shadow-sm hover:bg-orange-600">
          <font-awesome-icon icon="external-link-alt" />
          <span class="ml-2 align-middle">Accéder au module</span>
        </div>
        <div
          v-if="inscription.elearningMixte && inscription.elearningMixte.url"
          v-on:click.stop="openFormateurElearningModule"
          class="my-2 flex w-72 cursor-pointer items-center justify-center rounded bg-orange-500 px-4 py-2 text-center text-sm font-bold uppercase leading-none text-white shadow-sm hover:bg-orange-600">
          <font-awesome-icon icon="external-link-alt" />
          <span class="ml-2 align-middle">Accéder au module</span>
        </div>
        <div
          v-if="
            inscription.sessionUrlParticipant &&
            inscription.sessionUrlParticipant.length > 1
          "
          v-on:click.stop="openConnexionModal"
          class="my-2 flex w-72 cursor-pointer items-center justify-center rounded bg-orange-500 px-4 py-2 text-center text-sm font-bold uppercase leading-none text-white shadow-sm hover:bg-orange-600">
          <font-awesome-icon icon="external-link-alt" />
          <span class="ml-2 align-middle"> Informations de connexion </span>
        </div>
      </div>
    </div>
  </div>
  <participants-modal
    v-if="
      inscription.participants &&
      inscription.participants.length > participants_number_to_display
    "
    v-bind:modal_show="participants_modal"
    v-bind:onclose="closeParticipantsModal"
    v-bind:participants="inscription.participants" />
  <connexion-modal
    v-bind:modal_show="connexion_modal"
    v-on:onclose="closeConnexionModal"
    v-if="
      inscription.sessionUrlParticipant &&
      inscription.sessionUrlParticipant.length > 0
    "
    v-bind:session_url="inscription.sessionUrlParticipant" />
</template>

<script>
  import { convertStringToDate } from '@/assets/data/ag_grid_fields_map';
  import { map_type_colors } from '@/assets/data/data_maps.js';
  import { API } from '@/http-common';
  import dates_helpers from '@/mixin/dates_helpers';
  import http_functions from '@/mixin/http_functions';
  import participantsModal from '@/views/_espace/_entreprise/_sessions/_modal/participants-modal';
  import ConnexionModal from '@/views/_espace/connexion-modal';

  export default {
    components: { participantsModal, ConnexionModal },
    mixins: [dates_helpers, http_functions],
    props: {
      inscription: {
        type: Object,
        default: null
      },
      parcours: {
        type: Boolean,
        default: false
      },
      collapsed: {
        type: Boolean,
        default: null
      },
      produit: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        connexion_modal: false,
        map_type_colors,
        participants_number_to_display: 5,
        participants_modal: false
      };
    },
    computed: {
      isSessionStatusCancel() {
        return this.inscription?.sessionStatut?.id === 5;
      },
      isFormateurStatusCancel() {
        return this.inscription?.formateurStatut?.id === 3;
      }
    },
    methods: {
      openConnexionModal() {
        this.connexion_modal = true;
      },
      closeConnexionModal() {
        this.connexion_modal = false;
      },
      goToUrl(url) {
        window.open(this.formatUrlProtocol(url), '_blank');
      },
      async openElearningModule() {
        const { commandeId, reference } = this.inscription;

        if (commandeId && reference) {
          const response = await API.get(
            `participant/commande/${commandeId}/formation/${reference}/elearning`,
            this.$header_skip_redirection
          );

          if (response && response.data && response.data.url) {
            window.open(response.data.url);
          }
        }
      },
      async openFormateurElearningModule() {
        if (this.inscription.elearningMixte?.url) {
          window.open(this.inscription.elearningMixte?.url);
        }
      },
      type_text_color(id) {
        return `text-${map_type_colors[id]}`;
      },
      displayDates(dates) {
        const sortedDates = dates
          .slice()
          .sort(
            (a, b) =>
              convertStringToDate(a.date).getTime() -
              convertStringToDate(b.date).getTime()
          );

        return sortedDates.map(
          (date) =>
            `${date.date}${date.matin && !date.aprem ? ' (matin)' : ''}${!date.matin && date.aprem ? ' (après-midi)' : ''}`
        );
      },
      displayParticipants(participants) {
        return participants
          .slice(0, this.participants_number_to_display)
          .map(
            (participant) =>
              `${participant.prenom && participant.nom ? `${participant.prenom} ${participant.nom}` : 'Réservation'} ${participant.statut ? `(${participant.statut.label})` : ''}`
          );
      },
      openParticipantsModal(e) {
        e.stopPropagation();
        if (
          this.inscription.participants.length >
          this.participants_number_to_display
        ) {
          this.participants_modal = true;
        }
      },
      closeParticipantsModal() {
        this.participants_modal = false;
      }
    }
  };
</script>
<style lang="scss" scoped>
  .description__left {
    @apply w-full flex-col space-y-1 pl-5 pr-3;
  }

  .content__title {
    @apply mb-4 text-xl font-bold leading-tight;
    @supports (-webkit-line-clamp: 2) {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .content__reference {
    @apply mb-2 text-accent-500;
  }
</style>
